import 'css-chunksrc/client/scenes/calendar/week/dayCreationMenu/dateFields/styles.scss';export default {
  "checkbox": "_checkbox_t71hu_1",
  "row": "_row_t71hu_10",
  "dateGroup": "_dateGroup_t71hu_20",
  "dateTimeInput": "_dateTimeInput_t71hu_30",
  "partialGroup": "_partialGroup_t71hu_35",
  "hoursGroup": "_hoursGroup_t71hu_41",
  "dateRow": "_dateRow_t71hu_50",
  "dateField": "_dateField_t71hu_55",
  "dateLabel": "_dateLabel_t71hu_62"
};